import { RxUtil } from '@commons/util/utilities/rx';
import { IPromise, IQService, isDefined } from 'angular';
import { i18n } from 'i18next';
import { take } from 'rxjs';

import {
  COMETD_SMS_SEND_INFO,
  COMETD_SMS_SEND_STATUS,
  isNotNullOrUndefined,
  MessagingService,
  Sms,
  SmsConfiguration,
  SmsFacade,
  SmsService,
  ToasterFacade,
} from '@contact/upgrade';

const MODULE_NAME = 'smsDeprecatedService';

const SMS_SEND_STATUS_OK = 'OK';
const SMS_SEND_STATUS_ERROR = 'ERROR';

/**
 *  @deprecated
 */
export interface ISmsDeprecatedService {
  /**
   *  @deprecated
   */
  phoneNumberToUse: string;

  /**
   *  @deprecated
   */
  pushSMS(smsToSend: Sms): IPromise<any>;

  /**
   *  @deprecated
   */
  getConfiguration(): IPromise<SmsConfiguration>;

  /**
   *  @deprecated
   */
  openSMS();

  /**
   *  @deprecated
   */
  openSMSForContact(contactId: string);
}

/**
 *  @deprecated
 */
export class SmsDeprecatedService implements ISmsDeprecatedService {
  static $inject = ['$q', '$i18next', 'messaging', 'toasterFacade', 'smsService', 'smsFacade'];

  configuration: SmsConfiguration;
  phoneNumberToUse: string = '';

  constructor(
    private readonly $q: IQService,
    private readonly $i18next: i18n,
    private readonly messaging: MessagingService,
    private readonly toasterFacade: ToasterFacade,
    private readonly smsService: SmsService,
    private readonly smsFacade: SmsFacade
  ) {
    this.messaging
      .forRemote()
      .listen$(COMETD_SMS_SEND_INFO)
      .subscribe(() => {
        this.toasterFacade.notification({
          message: this.$i18next.t('agent:toast.sms_send_info_supported_by_worldline'),
          duration: 2000,
        });
      });

    this.messaging
      .forRemote()
      .listen$(COMETD_SMS_SEND_STATUS)
      .subscribe((dto: any) => {
        if (dto.status === SMS_SEND_STATUS_OK) {
          this.toasterFacade.notification({
            message:
              dto.contactFirstName != null
                ? this.$i18next.t('agent:toast.sms_send_status_successfully_sent_to_contact', {
                    contactFormattedName:
                      dto.contactLastName != null ? dto.contactFirstName + ' ' + dto.contactLastName : dto.contactFirstName,
                  })
                : this.$i18next.t('agent:toast.sms_send_status_successfully_sent_to_phone_number', {
                    phoneNumber: dto.phoneNumber,
                  }),
            duration: 2000,
          });
        } else if (dto.status === SMS_SEND_STATUS_ERROR) {
          this.toasterFacade.alert({
            message: this.$i18next.t('agent:toast.sms_send_status_technical_incident_happened'),
            duration: 2000,
          });
        } else {
          // do nothing here yet
        }
      });
  }

  /**
   *  @deprecated
   */
  getConfiguration(): IPromise<any> {
    let deferred = this.$q.defer();
    if (!isDefined(this.configuration)) {
      RxUtil.toPromise(this.smsService.get().pipe(isNotNullOrUndefined(), take(1)), this.$q).then(
        configuration => {
          this.configuration = configuration;
          deferred.resolve(this.configuration);
        },
        () => {
          deferred.reject('cannot load sms configuration');
        }
      );
    } else {
      deferred.resolve(this.configuration);
    }
    return deferred.promise;
  }

  /**
   *  @deprecated
   */
  pushSMS(sms: Sms): IPromise<any> {
    let deferred = this.$q.defer();

    RxUtil.toPromise(this.smsService.send(sms), this.$q).then(
      response => {
        if (!!response) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      },
      () => {
        deferred.reject();
      }
    );

    return deferred.promise;
  }

  /**
   *  @deprecated
   */
  openSMS(): void {
    this.internalOpenSms();
  }

  /**
   *  @deprecated
   */
  openSMSForContact(contactId: string): void {
    this.internalOpenSms(contactId);
  }

  /**
   *  @deprecated
   */
  private internalOpenSms(customerId?: string): void {
    this.smsFacade.openDialog({
      customerId,
    });
  }
}

export default MODULE_NAME;
